export default {
  // Textos específicos de Campus
  phone: 'Teléfono',
  address2Optional: '2 (Opcional)',
  postalCode: 'Código postal',
  institutionNotFound: 'Institución no encontrada!!!',
}
